import { render, staticRenderFns } from "./Priority.vue?vue&type=template&id=0e159032&scoped=true&"
import script from "./Priority.vue?vue&type=script&lang=js&"
export * from "./Priority.vue?vue&type=script&lang=js&"
import style0 from "./Priority.vue?vue&type=style&index=0&id=0e159032&lang=scss&scoped=true&"
import style1 from "./Priority.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e159032",
  null
  
)

export default component.exports